module.exports = __webpack_public_path__ + "img/money.e529a74a.svg";